/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SharedProjectDto } from './sharedProjectDto';
import { User } from './user';

export interface WorkflowDefinition { 
    id?: string;
    name?: string;
    version?: string;
    description?: string;
    status?: WorkflowDefinition.StatusEnum;
    definitionType?: WorkflowDefinition.DefinitionTypeEnum;
    manifestJson?: string;
    projectId?: number;
    slug?: string;
    visibility?: WorkflowDefinition.VisibilityEnum;
    readOnly?: boolean;
    publishedId?: string;
    autoForRulesetId?: string;
    testRun?: boolean;
    sourceCatalogKey?: string;
    sourceCatalogVersion?: number;
    createdAt?: Date;
    updatedAt?: Date;
    archivedBy?: User;
    archivedAt?: Date;
    sharedProjects?: Array<SharedProjectDto>;
    autoGenerated?: boolean;
}
export namespace WorkflowDefinition {
    export type StatusEnum = 'DRAFT' | 'ACTIVE' | 'INACTIVE' | 'ARCHIVED';
    export const StatusEnum = {
        DRAFT: 'DRAFT' as StatusEnum,
        ACTIVE: 'ACTIVE' as StatusEnum,
        INACTIVE: 'INACTIVE' as StatusEnum,
        ARCHIVED: 'ARCHIVED' as StatusEnum
    };
    export type DefinitionTypeEnum = 'WORKFLOW' | 'HYBRID_RULESET' | 'HYBRID_RULE';
    export const DefinitionTypeEnum = {
        WORKFLOW: 'WORKFLOW' as DefinitionTypeEnum,
        HYBRIDRULESET: 'HYBRID_RULESET' as DefinitionTypeEnum,
        HYBRIDRULE: 'HYBRID_RULE' as DefinitionTypeEnum
    };
    export type VisibilityEnum = 'PUBLIC' | 'PRIVATE';
    export const VisibilityEnum = {
        PUBLIC: 'PUBLIC' as VisibilityEnum,
        PRIVATE: 'PRIVATE' as VisibilityEnum
    };
}